var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#0E72ED",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.2929V6.5C9.5 6.22388 9.72388 6 10 6C10.2761 6 10.5 6.22388 10.5 6.5V12.2929L12.6465 10.1464C12.8418 9.95117 13.1582 9.95117 13.3535 10.1464C13.5488 10.3417 13.5488 10.6583 13.3535 10.8536L10.3535 13.8536C10.1582 14.0488 9.8418 14.0488 9.64648 13.8536L6.64648 10.8536C6.45117 10.6583 6.45117 10.3417 6.64648 10.1464C6.8418 9.95117 7.1582 9.95117 7.35352 10.1464L9.5 12.2929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.9a34e49f9c484c5f2a25a874bcaa7f14.svg";
export { ForwardRef as ReactComponent };